/**
 * Tells the customer that the editor could not be started because
 * the user token was not obtained, and what they can do about it.
 */
export function showUserTokenAlert(reason?: string | null) {
    const lines = [
        'Sorry, we could not load the personalization editor.',
        '',
        'Please try the following:',
        '1. Reload the page.',
        '2. Disable ad blockers or privacy extensions for this site.',
        '3. Make sure cookies and site data are allowed in your browser.',
        '4. If the problem persists, please contact our customer service.',
    ];

    if (reason) {
        lines.push('', `Error details: ${reason}`);
    }

    alert(lines.join('\n'));
}
